import { TextInput } from 'modules/TextInput';
import { MenuInput } from './MenuInput';
import { InputContainer } from './styled';
export function MenuTextInput(props) {
    return (<MenuInput render={<InputContainer>
          <TextInput {...props} stretch/>
        </InputContainer>}/>);
}
